import React from 'react'
import { is } from '../../../components/MediaQuery'

export function withIsDesktop(C) {
  return function(props) {
    const isDesktop = is.desktop()
    return <C {...props} isDesktop={isDesktop} />
  }
}

export function withIsHorizontal(C) {
  return function(props) {
    const isHorizontal = is.horizontal()
    return <C {...props} isHorizontal={isHorizontal}/>
  }
}
